(function () {
  'use strict';
  const C = window.HYDRATION_CONFIG;

  // Allow Shopify section settings (and any host page) to override editable copy.
  const O = window.FUEL24_OVERRIDES || {};
  if (O.electrolytesTagline) {
    C.electrolytesTagline = C.electrolytesTagline || {};
    if (O.electrolytesTagline.heading) C.electrolytesTagline.heading = O.electrolytesTagline.heading;
    if (O.electrolytesTagline.sub)     C.electrolytesTagline.sub     = O.electrolytesTagline.sub;
  }
  if (O.electrolytesPitch) C.electrolytesPitch = O.electrolytesPitch;
  if (O.recommendation) {
    C.recommendation = Object.assign({}, C.recommendation || {}, O.recommendation);
  }

  // ---------- State ----------
  const state = {
    step: 1,
    units: 'metric',
    gender: 'male',
    lifeStage: 'none',
    age: 25,
    weightKg: 80,
    heightCm: 170,
    activity: 'medium',
    climate: 'temperate',
    eventEnabled: false,
    event: { sport: 'none', durationMin: 0, intensity: 'moderate', customMlPerMin: 12 },
    intake: { water: 0, coffee_tea_soft: 0, alcohol: 0, electrolyte_milk: 0 },
  };

  // ---------- DOM helpers ----------
  const el = (tag, attrs, ...kids) => {
    const n = document.createElement(tag);
    if (attrs) for (const [k, v] of Object.entries(attrs)) {
      if (k === 'class') n.className = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k === 'style' && typeof v === 'string') n.setAttribute('style', v);
      else if (k.startsWith('on') && typeof v === 'function') n.addEventListener(k.slice(2), v);
      else if (v !== false && v != null) n.setAttribute(k, v);
    }
    for (const kid of kids) if (kid != null && kid !== false) n.append(kid.nodeType ? kid : document.createTextNode(kid));
    return n;
  };
  const $ = (sel, root) => (root || document).querySelector(sel);

  // ---------- Icon set ----------
  // Lucide for utility/nav (lucide.dev — MIT), branded SVGs from /temp for content.
  const L = (path) => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + path + '</svg>';
  const ICONS = {
    // Branded (sanitized to currentColor so they recolor on active states)
    male:    '<svg viewBox="0 0 16 16" fill="currentColor"><path fill-rule="evenodd" d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2H9.5zM6 6a4 4 0 1 0 0 8a4 4 0 0 0 0-8z"/></svg>',
    female:  '<svg viewBox="0 0 32 32" fill="currentColor"><path d="M17 19.93a8 8 0 1 0-2 0V22h-5v2h5v4h2v-4h5v-2h-5ZM10 12a6 6 0 1 1 6 6a6.007 6.007 0 0 1-6-6Z"/></svg>',
    gender:  '<svg viewBox="0 0 32 32" fill="currentColor"><path d="M16 5c-3.854 0-7 3.146-7 7c0 2.41 1.23 4.552 3.094 5.813C8.527 19.343 6 22.88 6 27h2c0-4.43 3.57-8 8-8s8 3.57 8 8h2c0-4.12-2.527-7.658-6.094-9.188A7.02 7.02 0 0 0 23 12c0-3.854-3.146-7-7-7zm0 2c2.773 0 5 2.227 5 5s-2.227 5-5 5s-5-2.227-5-5s2.227-5 5-5z"/></svg>',
    age:     '<svg viewBox="0 0 512 512" fill="currentColor"><path d="M360 73c-14.43 0-27.79 7.71-38.055 21.395c-10.263 13.684-16.943 33.2-16.943 54.94c0 21.74 6.68 41.252 16.943 54.936c10.264 13.686 23.625 21.396 38.055 21.396s27.79-7.71 38.055-21.395C408.318 190.588 415 171.075 415 149.335c0-21.74-6.682-41.255-16.945-54.94C387.79 80.71 374.43 73 360 73zm-240 96c-10.012 0-19.372 5.32-26.74 15.145C85.892 193.968 81 208.15 81 224c0 15.85 4.892 30.032 12.26 39.855C100.628 273.68 109.988 279 120 279c10.012 0 19.374-5.32 26.742-15.145c7.368-9.823 12.256-24.006 12.256-39.855c0-15.85-4.888-30.032-12.256-39.855C139.374 174.32 130.012 169 120 169zm188.805 47.674a77.568 77.568 0 0 0-4.737 3.974c-13.716 12.524-23.816 31.052-31.53 54.198c-14.59 43.765-20.404 103.306-30.063 164.154h235.05c-9.66-60.848-15.476-120.39-30.064-164.154c-7.714-23.146-17.812-41.674-31.528-54.198a76.795 76.795 0 0 0-4.737-3.974c-12.84 16.293-30.942 26.994-51.195 26.994s-38.355-10.7-51.195-26.994zM81.27 277.658c-.573.485-1.143.978-1.702 1.488c-9.883 9.024-17.315 22.554-23.03 39.7c-10.6 31.8-15.045 75.344-22.063 120.154h171.048c-7.017-44.81-11.462-88.354-22.062-120.154c-5.714-17.146-13.145-30.676-23.028-39.7a59.378 59.378 0 0 0-1.702-1.488C148.853 289.323 135.222 297 120 297c-15.222 0-28.852-7.678-38.73-19.342z"/></svg>',
    height:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9.524 22v-4.5a2 2 0 0 1 2-2v-6s-1.5-1-4-1s-4 1-4 1v6a2 2 0 0 1 2 2V22M23.936.5H.064m23.872 23H.064M18.524 3v18m0-18c0 .358.205.804.419 1.171c.285.49.66.918 1.088 1.276c.332.278.728.553.993.553m-2.5-3c0 .358-.206.804-.42 1.171c-.285.49-.659.918-1.087 1.276c-.333.278-.728.553-.993.553m2.5 15c0-.358.205-.804.419-1.171c.285-.49.66-.918 1.088-1.276c.332-.278.728-.553.993-.553m-2.5 3c0-.358-.206-.804-.42-1.171a4.856 4.856 0 0 0-1.087-1.276c-.333-.278-.728-.553-.993-.553M7.374 6.5s-1.6-1-1.6-2.25a1.746 1.746 0 1 1 3.495 0c0 1.25-1.595 2.25-1.595 2.25h-.3Z"/></svg>',
    weight:  '<svg viewBox="0 0 512 512" fill="currentColor"><path d="M69.14 41L41 67.85V444.3L67.12 471H444.3l26.7-26.7V67.73L444.3 41H69.14zM247 72.07V112h18V72.07c25.3.3 50.5 1.83 74.6 4.63l-12.3 49.1l17.4 4.4l12.8-51.15C384.7 83.02 410 88.67 432 96l-48 112c-26.1-6.5-62.9-10.4-101.5-11.6c4.1 5.5 6.5 12.3 6.5 19.6c0 18.1-14.9 33-33 33s-33-14.9-33-33c0-7.3 2.4-14.1 6.5-19.6c-38.7 1.2-75.4 5.1-101.5 11.6L80 96c22-7.33 47.3-12.98 74.5-16.95l12.8 51.15l17.4-4.4l-12.3-49.1c24.1-2.8 49.3-4.33 74.6-4.63zm-30.7 20.39l-16.6 7.08l38.1 88.96c5.1-3.3 11-5.3 17.4-5.5l-38.9-90.54zM256 201c-8.4 0-15 6.6-15 15s6.6 15 15 15s15-6.6 15-15s-6.6-15-15-15zM128 359h256v18H128v-18zm0 48h256v18H128v-18z"/></svg>',
    activity:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m8.11 15.89l7.779-7.78M2 22l1.848-1.848M22 2l-1.848 1.848M2.1 9.878L14.121 21.9l-.177.177l-1.737-.208c-1.75-.21-3.522.138-5.098.926L6.697 23L1 17.303l.206-.412c.788-1.576 1.136-3.348.926-5.098l-.208-1.737l.176-.177Zm7.78-7.776l12.02 12.02l.177-.177l-.208-1.737c-.21-1.75.138-3.522.926-5.098L23 6.697L17.303 1l-.413.206c-1.575.788-3.348 1.136-5.097.926l-1.738-.208l-.176.177Z"/></svg>',
    climate: '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm-3.5 1.5a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm.747-8.498a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973zM8.5 2a4 4 0 0 1 3.976 3.555a.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926a.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 2z"/></svg>',
    water:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22a8 8 0 0 1-8-8c0-3.502 2.71-6.303 5.093-8.87L12 2l2.907 3.13C17.29 7.698 20 10.499 20 14a8 8 0 0 1-8 8Z"/></svg>',
    alcohol: '<svg viewBox="0 0 48 48" fill="currentColor"><path fill-rule="evenodd" d="M19.5 5a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1v12.182a.715.715 0 0 1-.237.531A14.39 14.39 0 0 0 10 28.408v13.384c0 1.22.989 2.208 2.208 2.208h9.435A2.356 2.356 0 0 0 24 41.644V28.063c0-3.882-1.542-7.605-4.287-10.35a.727.727 0 0 1-.213-.514V5ZM12 29h10v8H12v-8Zm23.639-5H28.36l.64-6h6l.638 6ZM27.2 16h9.6l1.013 9.536A5.848 5.848 0 0 1 33 31.916V42h3a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h3V31.915a5.848 5.848 0 0 1-4.813-6.379L27.2 16Z" clip-rule="evenodd"/></svg>',
    electrolyte: '<svg viewBox="0 0 1024 1024" fill="currentColor"><path d="M595.344 64.72h.176h-.176zm0 0l-72.207 379.377l261.584.88L428.657 959.28l72.208-417.376l-261.568-.912zm.049-63.999c-1.728 0-3.455.063-5.151.19c-11.296.913-18.785 4.689-27.664 10.657a64.304 64.304 0 0 0-13.392 11.936a56.688 56.688 0 0 0-3.297 4.288L187.281 502.4c-14.16 19.408-16.24 45.025-5.36 66.433c10.864 21.408 32.832 34.976 56.912 35.152l184.736 1.344l-58.08 342.192c-5.52 29.408 10.16 58.72 37.76 70.528a64.19 64.19 0 0 0 25.391 5.216c20.112 0 36.64-9.408 49.041-26.4L836.737 482.56c14.16-19.409 16.225-45.057 5.36-66.433c-10.864-21.408-32.832-34.977-56.912-35.152l-184.736-.32l57.456-300.88a62.46 62.46 0 0 0 1.825-15.056c0-34.624-27.569-62.848-62.065-63.968c-.767-.032-1.52-.032-2.271-.032z"/></svg>',
    coffee:  '<svg viewBox="0 0 1024 1024" fill="currentColor"><path d="M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9c-.5 7-.7 14-.7 21.1c0 176.7 143.3 320 320 320c160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23c0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z"/></svg>',
    glass:   L('<path d="M5 3h14l-1.5 16a3 3 0 0 1-3 2.7H9.5a3 3 0 0 1-3-2.7L5 3Z"/><path d="M6.5 9h11"/>'),
    // utility (Lucide)
    chevron: L('<polyline points="6 9 12 15 18 9"/>'),
    check:   L('<polyline points="20 6 9 17 4 12"/>'),
    arrow:   L('<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>'),
    plus:    L('<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>'),
    minus:   L('<line x1="5" y1="12" x2="19" y2="12"/>'),
    refresh: L('<polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>'),
    walk:    L('<circle cx="13" cy="4" r="2"/><path d="m5 22 5-4M9 22V11l-3-1l-3 5"/><path d="m21 13-2-3-3 1-2 5l3 3v3"/>'),
    pregnant:     '<svg viewBox="0 0 32 32" fill="currentColor"><path d="M15.751 8.26c.2 0 .386.056.553.148c.398.14.706.485.797.913c.02.12-.08.23-.2.23h-.416h.346a.752.752 0 0 0-.05-.546a.784.784 0 0 0-.7-.434a.77.77 0 0 0-.74.98h.356h-.736c-.15 0-.27-.14-.22-.29c.009-.035.019-.07.03-.103l-.03-.027a.368.368 0 0 1 .02-.57c.28-.19.64-.3.99-.3Z"/><path d="m15.697 9.55l.004.01h.78l.004-.01a.444.444 0 0 0-.394-.64a.43.43 0 0 0-.168.035a.14.14 0 1 1-.21.184a.433.433 0 0 0-.062.222a.52.52 0 0 0 .046.2Zm4.594-1.3c.35 0 .71.11.99.3c.19.13.2.41.03.56l-.035.033a.928.928 0 0 1 .035.117c.04.15-.08.29-.23.29h-.726l-.004.01h-.78l-.005-.01h-.415c-.12 0-.22-.11-.2-.23c.081-.412.369-.75.75-.898c.176-.106.375-.172.59-.172Zm.064 1.3h.346a.77.77 0 0 0-.74-.98c-.43 0-.78.35-.78.77c0 .08.01.14.03.21h.355a.411.411 0 0 1-.045-.2c0-.083.024-.162.066-.229a.14.14 0 0 0 .254-.08a.14.14 0 0 0-.04-.1a.43.43 0 0 1 .16-.03a.444.444 0 0 1 .395.64Zm-2.344 2.41c-.45 0-.87-.11-1.23-.3c-.12-.06-.25.08-.18.2c.3.46.82.77 1.41.77s1.11-.3 1.41-.77c.07-.12-.05-.25-.18-.19c-.36.18-.78.29-1.23.29Zm-.76-1.39l.44-1.42c.1-.31.54-.31.63 0l.44 1.42c.09.29-.12.59-.43.59h-.65c-.3 0-.52-.3-.43-.59Zm-2.31-2.76a.22.22 0 0 1-.2-.12c-.07-.1-.03-.25.08-.31c.03-.02.78-.44 1.65-.28c.13.02.21.14.19.27c-.02.12-.15.21-.27.18c-.7-.13-1.33.23-1.33.23c-.04.03-.08.03-.12.03Zm6.02-.03a.247.247 0 0 0 .33-.09a.241.241 0 0 0-.112-.33c-.135-.068-.83-.416-1.628-.27a.23.23 0 0 0-.19.27c.02.13.15.21.27.19c.626-.117 1.203.168 1.312.222a.178.178 0 0 0 .018.009Z"/><path d="M24.251 10.63a2.858 2.858 0 0 0-.2-2.82c-.3-.46-.46-.99-.46-1.54v-.01a2.86 2.86 0 0 0-2.86-2.86c-.16 0-.3-.07-.39-.2c-.52-.73-1.37-1.2-2.33-1.2s-1.81.47-2.33 1.2c-.09.12-.24.2-.39.2a2.86 2.86 0 0 0-2.86 2.86v.01c0 .55-.16 1.08-.46 1.54a2.858 2.858 0 0 0-.2 2.82c.06.13.06.27 0 .4a2.791 2.791 0 0 0 2.437 4.01l-1.557 1.67c-.33.35-.53.82-.53 1.34c0 .5.19.96.49 1.3c.09.1.03.27-.1.29a6.385 6.385 0 0 0-5.308 6.168a1.662 1.662 0 0 0-1.198 1.444l-.001.014v.013c-.023.373.077.73.271 1.025a1.664 1.664 0 0 0 .423 1.337c.005.03.012.062.019.094l.002.01c.192.793.919 1.255 1.632 1.255h1.042c.036 0 .678.002 1.013-.054a12.73 12.73 0 0 0 .88-.162a19.184 19.184 0 0 0 2.68-.784h6.405c.96 0 1.74-.78 1.74-1.74V16.05c0-.36-.072-.702-.203-1.016a2.791 2.791 0 0 0 2.333-4.004a.505.505 0 0 1 .01-.4Zm-1.91-3.116a1.892 1.892 0 0 1 .04.386l-.005.125a1.4 1.4 0 0 1 1.133 1.373a1.4 1.4 0 0 1-1.257 1.392c-.227 2.284-2.049 3.79-4.24 3.79c-2.122 0-3.897-1.42-4.215-3.575a4.904 4.904 0 0 1-.026-.216a1.399 1.399 0 0 1-.119-2.764l-.01-.265c.007-.635.3-.96.78-1.28c.267-.178.526-.364.73-.6l.005-.005c.073-.085.14-.177.197-.277l.006-.01c.03-.054.057-.11.081-.168l.07-.15c.07-.17.3-.2.4-.05a3.23 3.23 0 0 0 .465.545l.006.005c.605.565 1.414.89 2.26.89h2.76c.14 0 .77.061.938.854ZM8.93 26.74l-.3-.3a.66.66 0 0 1 0-.92c.25-.25.67-.25.92 0l.54.54c.2.2.49.28.77.21c1.24-.31 3.31-.99 4.91-2.38a7.13 7.13 0 0 0 1.154-1.275a8.29 8.29 0 0 0 .658-1.106c.25-.503.442-1.007.588-1.48v-.009h3.601c-.072.317-.16.652-.266 1a13.39 13.39 0 0 1-.655 1.718a11.92 11.92 0 0 1-1.019 1.782a10.712 10.712 0 0 1-1.78 1.99c-3.166 2.74-7.354 3.38-7.78 3.445l-.03.005a1.145 1.145 0 0 1-.036.005C9.95 30 9.44 30 9.391 30h-1.04c-.31 0-.59-.2-.66-.49a.666.666 0 0 1 .02-.37a.645.645 0 0 1-.45-.62c0-.2.09-.38.23-.5a.64.64 0 0 1-.49-.68a.672.672 0 0 1 .67-.6h1.26Z"/></svg>',
    breastfeeding: '<svg viewBox="0 0 32 32" fill="currentColor"><path d="M16.88 14.275c-.6.11-1.19.06-1.71-.11c-.18-.06-.32.16-.19.3c.51.55 1.27.83 2.06.69s1.41-.67 1.7-1.35c.07-.17-.13-.33-.28-.21c-.44.33-.98.57-1.58.68Zm-1.25-1.499l.23-1.85c.05-.41.6-.5.79-.13l.85 1.65c.17.34-.03.75-.41.82l-.8.14a.566.566 0 0 1-.66-.63Zm-3.45-2.9c-.1.02-.21-.02-.27-.1c-.1-.12-.09-.31.04-.41l.009-.007c.098-.077.905-.713 1.961-.703a.29.29 0 0 1 0 .58c-.805 0-1.446.466-1.569.555l-.021.015a.34.34 0 0 1-.15.07Zm7.41-1.34c.05.02.1.02.15.01c.1-.02.18-.09.22-.18a.281.281 0 0 0-.17-.37l-.016-.005c-.139-.043-1.102-.344-2.074.015c-.15.05-.23.22-.17.37c.05.15.22.23.37.17c.773-.289 1.564-.048 1.676-.014l.01.003h.004Zm-.01 1.689c-.08.01-.14.06-.19.13c-.16.26-.42.45-.74.51s-.63-.03-.86-.23a.286.286 0 0 0-.22-.06c-.22.04-.3.32-.12.47c.35.29.82.43 1.3.34c.48-.08.87-.37 1.11-.77c.11-.19-.06-.43-.28-.39Zm-4.82.94c.05-.07.11-.12.19-.13c.22-.03.39.21.28.4c-.24.4-.63.69-1.11.77c-.48.09-.95-.05-1.3-.34c-.18-.15-.1-.43.12-.47c.08-.02.16.01.22.06c.24.19.55.28.86.22c.32-.06.58-.25.74-.51Z"/><path d="M24.25 11.316c.14-.5.17-1.04.08-1.59c-.13-.72-.46-1.35-.93-1.84c-.47-.5-.78-1.12-.9-1.79v-.01a3.58 3.58 0 0 0-4.14-2.9a.61.61 0 0 1-.53-.16a3.56 3.56 0 0 0-3.12-.97c-1.19.2-2.14.97-2.62 1.97c-.08.18-.25.3-.44.33c-1.95.35-3.25 2.2-2.9 4.15v.01c.12.67.04 1.37-.23 1.99c-.27.62-.37 1.33-.24 2.05c.1.55.31 1.04.62 1.47c.1.14.13.32.08.49c-.14.49-.18 1.03-.08 1.57a3.475 3.475 0 0 0 1.855 2.506a9.935 9.935 0 0 0-1.774 1.793l-4.301 5.26c-.433.482-.68 1.164-.68 1.85a2.5 2.5 0 0 0 2.5 2.5h7.417a.575.575 0 0 0 .083 0h11.22c.98 0 1.77-.8 1.77-1.78l-.01-1.99a9.7 9.7 0 0 0-.018-.588a4.8 4.8 0 0 0-3.603-7.572a10.54 10.54 0 0 0-1.198-.777a3.488 3.488 0 0 0 2.79-4.043c-.1-.54-.31-1.03-.61-1.44a.539.539 0 0 1-.09-.49Zm-11.78 14.74l-.043-.008a3.216 3.216 0 0 1 1.27-1.335l2.432-1.4a3.247 3.247 0 0 1 2.121-.398c.008.65.145 1.27.388 1.834a.598.598 0 0 0 .101.22a4.751 4.751 0 0 0 .352.604a.568.568 0 0 0-.411.282c-.15.27-.05.62.22.77l1.758.983c-.184.36-.437.688-.754.962a1.003 1.003 0 0 0-.904-.575h-2.4c-.09 0-.13-.11-.07-.17l.24-.24a.996.996 0 1 0-1.41-1.41l-1.387 1.388a1.868 1.868 0 0 0-1.503-1.508Zm10.58-7a3.8 3.8 0 0 1 2.648 6.525l.004.006a4.175 4.175 0 0 1-.428.358a2.215 2.215 0 0 0-.104-.23c-.23-.43-.4-.89-.5-1.36a9.65 9.65 0 0 1-.19-1.28a.625.625 0 0 0-.66-.58c-.34.02-.6.32-.58.66c0 .03.03.37.1.86c.01.07-.07.11-.12.07c-.77-.61-1.54-1.5-1.84-1.88a.55.55 0 0 0-.79-.09a.55.55 0 0 0-.09.79l.038.047c.062.076.196.24.383.452c.055.136.118.27.188.403a17.452 17.452 0 0 1-.97-.971l-.01-.01a.568.568 0 0 0-.879.05v-.02a3.794 3.794 0 0 1 3.125-3.74c.219-.04.445-.06.675-.06Zm-3.578 5.082a3.773 3.773 0 0 1-.144-.51c.155.163.745.754 1.342 1.308c.02.02 0 .04-.02.03l-1.15-.81a.687.687 0 0 0-.028-.018Zm2.128.107l-.055-.047a4.283 4.283 0 0 0-.167-.296l.082.083c.04.048.085.09.128.131l.062.06c.02.02.02.05 0 .07c-.02.01-.04.01-.05 0Zm-1.632-5.07a4.805 4.805 0 0 0-1.503 2.255a4.75 4.75 0 0 0-2.42.265a5.528 5.528 0 0 1-.645-2.6v-.561c.711.114 1.455.11 2.204-.024a6.556 6.556 0 0 0 2.557-1.025a9.501 9.501 0 0 1 1.624.74a4.78 4.78 0 0 0-1.817.95Zm-.515-2.42a5.574 5.574 0 0 1-2.023.77a5.514 5.514 0 0 1-2.53-.127a5.208 5.208 0 0 1-1.062-.446h.002a5.017 5.017 0 0 1-.86-.607c-.782-.686-1.37-1.632-1.646-2.792A1.757 1.757 0 0 1 9.38 12.11a1.76 1.76 0 0 1 1.201-1.98l-.01-.046c-.16-1.01.35-1.5.58-1.67a.714.714 0 0 1 .027-.016a.404.404 0 0 0 .073-.054c.52-.35.9-.89 1.03-1.52l.05-.21c.05-.22.32-.3.48-.14c.96.98 2.33 1.42 3.68 1.18l3.4-.6c.186-.029 1.158-.106 1.452 1.223h.002a1.76 1.76 0 0 1 .46 3.433a5.633 5.633 0 0 1-.044 1.615a5.06 5.06 0 0 1-2.31 3.427l.003.002Z"/></svg>',
    userX:   L('<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="17" y1="8" x2="22" y2="13"/><line x1="22" y1="8" x2="17" y2="13"/>'),
    // physical activity (lucide: dumbbell)
    dumbbell: L('<path d="M14.4 14.4 9.6 9.6"/><path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"/><path d="m21.5 21.5-1.4-1.4"/><path d="M3.9 3.9 2.5 2.5"/><path d="M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"/>'),
    // climate (lucide)
    sun:   L('<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/>'),
    snow:  L('<path d="M2 12h20"/><path d="M12 2v20"/><path d="m20 16-4-4 4-4"/><path d="m4 8 4 4-4 4"/><path d="m16 4-4 4-4-4"/><path d="m8 20 4-4 4 4"/>'),
    leaf:  L('<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/>'),
    cloud: L('<path d="M17.5 19a4.5 4.5 0 1 0 0-9h-1.8A7 7 0 1 0 4 16.6"/>'),
    // beverages (lucide)
    water:  L('<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/>'),
    coffee: L('<path d="M10 2v2"/><path d="M14 2v2"/><path d="M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1"/><path d="M6 2v2"/>'),
    wine:   L('<path d="M8 22h8"/><path d="M7 10h10"/><path d="M12 15v7"/><path d="M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z"/>'),
    bolt:   L('<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>'),
    glass:  L('<path d="M5 3h14l-1.5 16a3 3 0 0 1-3 2.7H9.5a3 3 0 0 1-3-2.7L5 3Z"/><path d="M6.5 9h11"/>'),
    // event/intensity (lucide: feather, flame, zap)
    feather: L('<path d="M12.67 19a2 2 0 0 0 1.416-.586l6.154-6.114a5 5 0 1 0-7.07-7.071L6.954 11.42A2 2 0 0 0 6.37 12.83L5.5 19.5l6.668-.5Z"/><path d="M16 8 2 22"/><path d="M17.5 15H9"/>'),
    flame:   L('<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>'),
    zap:     L('<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>'),
    // headers / misc
    timer:   L('<line x1="10" x2="14" y1="2" y2="2"/><line x1="12" x2="15" y1="14" y2="11"/><circle cx="12" cy="14" r="8"/>'),
    target:  L('<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>'),
    cup:     L('<path d="M5 3h14l-1.5 16a3 3 0 0 1-3 2.7H9.5a3 3 0 0 1-3-2.7L5 3Z"/>'),
    user:    L('<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'),
  };

  // ---------- Calculation ----------
  function ageDelta(age) {
    for (const m of C.ageModifiers) if (age <= m.maxAge) return m.deltaPerKg;
    return 0;
  }
  function eventBolus(ev, enabled) {
    if (!enabled) return 0;
    if (!ev || ev.sport === 'none' || !ev.durationMin) return 0;
    const base = ev.sport === 'custom' ? (ev.customMlPerMin || 0) : (C.eventMlPerMin[ev.sport] || 0);
    const mult = C.intensityMultiplier[ev.intensity] || 1;
    return Math.round(base * mult * ev.durationMin);
  }
  function calculate(s) {
    const baseline = (C.baselinePerKg + ageDelta(s.age)) * s.weightKg;
    const activity = C.activityBonus[s.activity] || 0;
    const climate = C.climateBonus[s.climate] || 0;
    const life = s.gender === 'female' ? (C.lifeStageBonus[s.lifeStage] || 0) : 0;
    const event = eventBolus(s.event, s.eventEnabled);
    const totalTarget = Math.max(0, Math.round(baseline + activity + climate + life + event));
    const foodWater = Math.round(totalTarget * C.foodWaterFraction);
    const fluidTarget = Math.max(0, totalTarget - foodWater);
    const w = C.beverageWeights, g = C.glassSize, k = s.intake;
    const breakdown = {
      water: Math.round(k.water * g.water * w.water),
      coffee_tea_soft: Math.round(k.coffee_tea_soft * g.coffee_tea_soft * w.coffee_tea_soft),
      alcohol: Math.round(k.alcohol * g.alcohol * w.alcohol),
      electrolyte_milk: Math.round(k.electrolyte_milk * g.electrolyte_milk * w.electrolyte_milk),
    };
    const totalIntake = breakdown.water + breakdown.coffee_tea_soft + breakdown.alcohol + breakdown.electrolyte_milk;
    const gap = Math.max(0, fluidTarget - totalIntake);
    return { baseline, activity, climate, life, event, totalTarget, foodWater, fluidTarget, breakdown, totalIntake, gap };
  }

  // ---------- Formatting ----------
  function fmtMl(ml) {
    if (state.units === 'imperial') {
      const oz = ml / C.mlPerFlOz;
      return oz.toFixed(1) + ' fl oz';
    }
    return Math.round(ml) + ' ml';
  }

  // ---------- Wizard nav ----------
  function maxStep() { return 5; }
  function goTo(step) {
    state.step = Math.max(1, Math.min(maxStep(), step));
    render();
    document.querySelector('.calc-card')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---------- Custom dropdown component ----------
  function Dropdown(options, currentValue, onChange, placeholder) {
    const wrap = el('div', { class: 'cdd' });
    const current = options.find(o => o.value === currentValue) || options[0];
    const toggle = el('button', { class: 'cdd-toggle', type: 'button' });
    const lblSpan = el('span', null, current ? current.label : (placeholder || 'Select…'));
    toggle.append(lblSpan);
    toggle.insertAdjacentHTML('beforeend', '<span class="arrow">' + ICONS.chevron + '</span>');
    const menu = el('div', { class: 'cdd-menu', role: 'listbox' });
    options.forEach(o => {
      const item = el('div', {
        class: 'cdd-item' + (o.value === currentValue ? ' selected' : ''),
        role: 'option',
        onclick: () => {
          lblSpan.textContent = o.label;
          [...menu.children].forEach(c => c.classList.remove('selected'));
          item.classList.add('selected');
          close();
          onChange(o.value);
        }
      });
      item.append(el('span', null, o.label));
      item.insertAdjacentHTML('beforeend', '<span class="check">' + ICONS.check + '</span>');
      menu.append(item);
    });
    wrap.append(toggle, menu);

    function open() { toggle.classList.add('open'); menu.classList.add('open'); document.addEventListener('mousedown', onDoc); }
    function close() { toggle.classList.remove('open'); menu.classList.remove('open'); document.removeEventListener('mousedown', onDoc); }
    function onDoc(e) { if (!wrap.contains(e.target)) close(); }
    toggle.addEventListener('click', () => { menu.classList.contains('open') ? close() : open(); });
    return wrap;
  }

  // ---------- Custom slider — single input with gradient background ----------
  function Slider(min, max, value, onChange, options) {
    options = options || {};
    const wrap = el('div', { class: 'fc-slider-wrap' });
    const input = el('input', { type: 'range', min: String(min), max: String(max), value: String(value), step: String(options.step || 1), class: 'fc-slider' });
    const paint = (v) => {
      const pct = ((v - min) / (max - min)) * 100;
      input.style.setProperty('--fc-p', pct + '%');
    };
    paint(value);
    input.addEventListener('input', e => {
      const v = options.step && options.step < 1 ? parseFloat(e.target.value) : parseInt(e.target.value, 10);
      paint(v);
      onChange(v);
    });
    wrap.append(input);
    return wrap;
  }

  // ---------- Intensity card group (3 selectable cards) ----------
  function IntensityCards(options, currentValue, onChange) {
    const wrap = el('div', { class: 'intensity-cards' });
    options.forEach(o => {
      const card = el('button', {
        type: 'button',
        class: 'int-card' + (o.value === currentValue ? ' active' : ''),
        onclick: () => {
          [...wrap.children].forEach(c => c.classList.remove('active'));
          card.classList.add('active');
          onChange(o.value);
        }
      });
      card.insertAdjacentHTML('beforeend', o.icon);
      card.append(el('div', { class: 'name' }, o.label));
      card.append(el('div', { class: 'sub' }, o.sub));
      wrap.append(card);
    });
    return wrap;
  }

  // ---------- Cards ----------
  function labelWithIcon(text, iconHtml, sub) {
    const lab = el('div', { class: 'card-label' + (iconHtml ? '' : ' no-icon') });
    if (iconHtml) {
      const ic = el('span', { class: 'lbl-icon' });
      ic.innerHTML = iconHtml;
      lab.append(ic);
    }
    lab.append(document.createTextNode(text));
    if (sub) lab.append(el('span', { class: 'card-sub' }, '  ' + sub));
    return lab;
  }

  // Editable counter — typeable input with +/- buttons.
  function counterCard(label, getValue, setValue, step, min, max, suffix, iconHtml, opts) {
    opts = opts || {};
    const card = el('div', { class: 'card' });
    card.append(labelWithIcon(label, iconHtml, opts.sub));
    const row = el('div', { class: 'counter' });
    const valueWrap = el('div', { class: 'counter-input' + (opts.size === 'small' ? ' small' : '') });
    const input = el('input', {
      type: 'text',
      inputmode: 'numeric',
      class: 'counter-num',
      value: String(getValue()),
      'aria-label': label,
    });
    if (suffix) valueWrap.append(input, el('span', { class: 'unit' }, suffix.trim()));
    else valueWrap.append(input);

    const clamp = v => Math.max(min, Math.min(max, v));
    const commit = () => {
      let n = parseInt(String(input.value).replace(/[^\d]/g, ''), 10);
      if (isNaN(n)) n = getValue();
      n = clamp(n);
      setValue(n);
      input.value = String(n);
    };
    input.addEventListener('blur', commit);
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); input.value = String(clamp(getValue() + step)); commit(); }
      if (e.key === 'ArrowDown') { e.preventDefault(); input.value = String(clamp(getValue() - step)); commit(); }
    });

    const dec = el('button', { class: 'circle-btn' + (opts.size === 'small' ? ' small' : ''), type: 'button', 'aria-label': 'decrease ' + label, onclick: () => {
      const v = clamp(getValue() - step); setValue(v); input.value = String(v);
    } });
    dec.innerHTML = ICONS.minus;
    const inc = el('button', { class: 'circle-btn' + (opts.size === 'small' ? ' small' : ''), type: 'button', 'aria-label': 'increase ' + label, onclick: () => {
      const v = clamp(getValue() + step); setValue(v); input.value = String(v);
    } });
    inc.innerHTML = ICONS.plus;
    row.append(dec, valueWrap, inc);
    card.append(row);
    return card;
  }

  function genderCard() {
    const card = el('div', { class: 'card' });
    const labelRow = labelWithIcon('Gender', ICONS.gender);

    if (state.gender === 'female') {
      // Reset button on the title row, on the right
      const reset = el('button', {
        type: 'button',
        class: 'reset-btn',
        title: 'Reset gender',
        'aria-label': 'Reset gender',
        onclick: () => { state.gender = 'male'; state.lifeStage = 'none'; render(); },
      });
      reset.innerHTML = ICONS.refresh;
      reset.append(el('span', null, 'Reset'));
      labelRow.append(reset);
    }
    card.append(labelRow);

    if (state.gender === 'female') {
      // Three lifestage cards instead of dropdown
      const cards = IntensityCards(
        [
          { value: 'none',          label: 'Neither',       sub: 'Not pregnant',    icon: ICONS.userX },
          { value: 'pregnant',      label: 'Pregnant',      sub: 'Expecting',       icon: ICONS.pregnant },
          { value: 'breastfeeding', label: 'Breastfeeding', sub: 'Nursing',         icon: ICONS.breastfeeding },
        ],
        state.lifeStage,
        v => { state.lifeStage = v; }
      );
      cards.classList.add('compact');
      card.append(cards);
    } else {
      const row = el('div', { class: 'gender-row' });
      const make = (val, label, icon) => {
        const b = el('button', {
          type: 'button',
          class: 'gender-btn' + (state.gender === val ? ' active' : ''),
          onclick: () => { state.gender = val; if (val === 'male') state.lifeStage = 'none'; render(); },
        });
        b.insertAdjacentHTML('beforeend', icon);
        b.append(el('span', { class: 'g-label' }, label));
        return b;
      };
      row.append(make('male', 'Male', ICONS.male), make('female', 'Female', ICONS.female));
      card.append(row);
    }
    return card;
  }

  function ageCard() {
    const card = el('div', { class: 'card' });
    card.append(labelWithIcon('Age', ICONS.age));
    const wrap = el('div', { class: 'big-input-wrap' });
    const input = el('input', {
      type: 'text',
      inputmode: 'numeric',
      class: 'big-input',
      value: String(state.age),
      'aria-label': 'Age',
    });
    const unit = el('span', { class: 'unit' }, 'years');
    wrap.append(input, unit);
    const slider = Slider(12, 100, state.age, v => {
      state.age = v;
      input.value = String(v);
    });
    const clamp = n => Math.max(12, Math.min(100, n));
    const commit = () => {
      let n = parseInt(String(input.value).replace(/[^\d]/g, ''), 10);
      if (isNaN(n)) n = state.age;
      n = clamp(n);
      state.age = n;
      input.value = String(n);
      const sliderInput = card.querySelector('.fc-slider');
      if (sliderInput) {
        sliderInput.value = String(n);
        const pct = ((n - 12) / (100 - 12)) * 100;
        sliderInput.style.setProperty('--fc-p', pct + '%');
      }
    };
    input.addEventListener('blur', commit);
    input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    card.append(wrap, slider);
    return card;
  }

  // ---------- Step 1 ----------
  function step1AboutYou() {
    const grid = el('div', { class: 'grid-2' });
    grid.append(genderCard(), ageCard());
    if (state.units === 'imperial') {
      grid.append(counterCard('Weight',
        () => Math.round(state.weightKg / C.kgPerLb),
        v => state.weightKg = v * C.kgPerLb,
        1, 44, 660, ' lb', ICONS.weight));
      grid.append(counterCard('Height',
        () => Math.round(state.heightCm / C.cmPerInch),
        v => state.heightCm = v * C.cmPerInch,
        1, 39, 90, ' in', ICONS.height));
    } else {
      grid.append(counterCard('Weight',
        () => Math.round(state.weightKg),
        v => state.weightKg = v,
        1, 20, 300, ' kg', ICONS.weight));
      grid.append(counterCard('Height',
        () => Math.round(state.heightCm),
        v => state.heightCm = v,
        1, 100, 230, ' cm', ICONS.height));
    }
    return wrapStep('Tell us about you', grid);
  }

  // ---------- Step 2 ----------
  function activityCard() {
    const card = el('div', { class: 'card' });
    card.append(labelWithIcon('Physical Activity', ICONS.activity));
    const cards = IntensityCards(
      [
        { value: 'low',    label: 'Low',    sub: 'Mostly seated',  icon: ICONS.feather },
        { value: 'medium', label: 'Medium', sub: 'Active most days', icon: ICONS.walk },
        { value: 'high',   label: 'High',   sub: 'Train often',     icon: ICONS.flame },
      ],
      state.activity,
      v => { state.activity = v; }
    );
    cards.classList.add('compact');
    card.append(cards);
    return card;
  }

  function climateCard() {
    const card = el('div', { class: 'card' });
    card.append(labelWithIcon('Climate', ICONS.climate));
    const cards = IntensityCards(
      [
        { value: 'cold',      label: 'Cold',      sub: 'Below 15°C',    icon: ICONS.snow },
        { value: 'temperate', label: 'Temperate', sub: '15 – 25°C',    icon: ICONS.leaf },
        { value: 'hot',       label: 'Hot',       sub: 'Above 25°C',   icon: ICONS.sun  },
      ],
      state.climate,
      v => { state.climate = v; }
    );
    cards.classList.add('compact');
    card.append(cards);
    return card;
  }

  function step2Lifestyle() {
    const grid = el('div', { class: 'grid-1' });
    grid.append(activityCard(), climateCard());
    return wrapStep('Tell us about you', grid);
  }

  // ---------- Step 3 (event) — with enable toggle ----------
  function eventCard() {
    const card = el('div', { class: 'card event-card' + (state.eventEnabled ? ' on' : ' off') });

    // Toggle header row
    const togRow = el('div', { class: 'event-toggle-row' });
    const togLabel = el('div', { class: 'event-toggle-label' });
    const ic = el('span', { class: 'lbl-icon' });
    ic.innerHTML = ICONS.flame;
    togLabel.append(ic);
    togLabel.append(el('div', { class: 'event-toggle-text' },
      el('strong', null, 'I have a specific event today'),
      el('span', null, 'Add a workout, race or training session to fine-tune your target.')
    ));
    const togSwitch = el('button', {
      type: 'button',
      class: 'event-switch' + (state.eventEnabled ? ' on' : ''),
      role: 'switch',
      'aria-checked': state.eventEnabled ? 'true' : 'false',
      'aria-label': 'Toggle specific event',
      onclick: () => { state.eventEnabled = !state.eventEnabled; render(); },
    });
    togSwitch.append(el('span', { class: 'event-switch-knob' }));
    togRow.append(togLabel, togSwitch);
    card.append(togRow);

    // Body (greyed out + non-interactive when disabled)
    const body = el('div', { class: 'event-body' + (state.eventEnabled ? '' : ' disabled') });
    if (!state.eventEnabled) body.setAttribute('aria-hidden', 'true');

    const sportRow = el('div', { class: 'event-row' });
    sportRow.append(el('label', null, 'Activity'));
    const sportDd = Dropdown(C.sportOptions, state.event.sport, v => { state.event.sport = v; updateCustomVisible(); refreshExtra(); });
    sportRow.append(sportDd);

    const durRow = el('div', { class: 'event-row' });
    durRow.append(el('label', null, 'Duration'));
    const dWrap = el('div', { class: 'duration-slider' });
    const dTop = el('div', { class: 'top' });
    const dValue = el('div', { class: 'value', html: state.event.durationMin + '<span class="unit">min</span>' });
    dTop.append(el('span', { style: 'font-size:13px;color:var(--muted);' }, 'How long?'), dValue);
    const dSlider = Slider(0, 240, state.event.durationMin, v => {
      state.event.durationMin = v;
      dValue.innerHTML = v + '<span class="unit">min</span>';
      refreshExtra();
    });
    const ticks = el('div', { class: 'ticks' });
    ['0', '30', '60', '90', '120', '180', '240'].forEach(t => ticks.append(el('span', null, t + 'm')));
    dWrap.append(dTop, dSlider, ticks);
    durRow.append(dWrap);

    const intRow = el('div', { class: 'event-row' });
    intRow.append(el('label', null, 'Intensity'));
    const seg = IntensityCards(
      [
        { value: 'light',    label: 'Light',    sub: 'Easy effort',  icon: ICONS.feather },
        { value: 'moderate', label: 'Moderate', sub: 'Steady pace',  icon: ICONS.flame },
        { value: 'hard',     label: 'Hard',     sub: 'High exertion', icon: ICONS.zap },
      ],
      state.event.intensity,
      v => { state.event.intensity = v; refreshExtra(); }
    );
    intRow.append(seg);

    const customRow = el('div', { class: 'event-row' });
    customRow.append(el('label', null, 'Custom ml lost / minute'));
    const customInp = el('input', { type: 'number', min: '0', max: '50', value: String(state.event.customMlPerMin), class: 'event-input' });
    customInp.addEventListener('input', e => {
      state.event.customMlPerMin = Math.max(0, parseInt(e.target.value || '0', 10));
      refreshExtra();
    });
    customRow.append(customInp);

    function updateCustomVisible() { customRow.style.display = state.event.sport === 'custom' ? 'grid' : 'none'; }
    updateCustomVisible();

    body.append(sportRow, durRow, intRow, customRow);

    const preview = el('div', { class: 'event-preview' });
    preview.append(
      el('span', { class: 'label' }, 'Estimated extra fluid for this event'),
      el('strong', { id: 'event-extra' }, fmtMl(eventBolus(state.event, state.eventEnabled)))
    );
    function refreshExtra() {
      const ext = $('#event-extra', card);
      if (ext) ext.textContent = fmtMl(eventBolus(state.event, state.eventEnabled));
    }
    body.append(preview);
    card.append(body);
    return card;
  }
  function step3Event() {
    return wrapStep('Today\'s training or event', el('div', { class: 'grid-1' }, eventCard()));
  }

  // ---------- Step 4 (intake) — same counterCard layout as Weight/Height ----------
  function step4Intake() {
    const wrap = el('div', { class: 'intake-wrap' });
    wrap.append(el('p', { class: 'step-intro' }, 'How many glasses do you consume?'));
    const grid = el('div', { class: 'grid-2' });
    grid.append(
      counterCard('Water',
        () => state.intake.water,
        v => state.intake.water = v,
        1, 0, 40, '', ICONS.water, { sub: '250 ml / glass' }),
      counterCard('Coffee / Tea / Soft Drinks',
        () => state.intake.coffee_tea_soft,
        v => state.intake.coffee_tea_soft = v,
        1, 0, 40, '', ICONS.coffee, { sub: '125 ml / glass' }),
      counterCard('Alcohol / Wine / Beer',
        () => state.intake.alcohol,
        v => state.intake.alcohol = v,
        1, 0, 40, '', ICONS.alcohol, { sub: '125 ml / glass' }),
      counterCard('Electrolyte Drink / Milk',
        () => state.intake.electrolyte_milk,
        v => state.intake.electrolyte_milk = v,
        1, 0, 40, '', ICONS.electrolyte, { sub: '250 ml / glass' }),
    );
    wrap.append(grid);
    return wrapStep('Daily liquid intake', wrap);
  }

  // ---------- Results ----------
  function rowKV(k, v, opts) {
    opts = opts || {};
    const row = el('div', { class: 'kv ' + (opts.kind || '') + (opts.strong ? ' strong' : '') });
    row.append(el('span', { class: 'k' }, k), el('span', { class: 'v' }, v));
    return row;
  }

  function bottlesGrid(r) {
    const grid = el('div', { class: 'bottles' });
    C.products.forEach(p => {
      const refills = r.gap > 0 ? r.gap / p.volumeMl : 0;
      const refillsLabel = refills < 0.05 ? '0 refills' : (Math.round(refills * 10) / 10).toFixed(1) + ' refills';
      const a = el('a', { class: 'bottle', href: p.url, target: '_blank', rel: 'noopener' });
      const img = el('div', { class: 'bottle-img' });
      img.append(el('img', { src: p.image, alt: p.name + ' ' + p.volumeLabel, loading: 'lazy' }));
      a.append(
        img,
        el('div', { class: 'bottle-tag' }, p.tagline),
        el('div', { class: 'bottle-name' }, p.name),
        el('div', { class: 'bottle-vol' }, p.volumeLabel + ' · ' + p.price),
        el('div', { class: 'bottle-refills' + (refills < 0.05 ? ' zero' : '') }, refillsLabel),
      );
      grid.append(a);
    });
    return grid;
  }

  function electrolyteServings(s) {
    return typeof C.electrolyteServings === 'function' ? C.electrolyteServings(s) : 0;
  }

  function electrolytesHero(s) {
    const servings = electrolyteServings(s);
    const tag = C.electrolytesTagline || {};
    const prod = C.electrolyteProduct || {};
    const wrap = el('div', { class: 'eh-block' });

    // Tagline
    const heading = el('div', { class: 'eh-tagline' });
    heading.append(el('h3', null, tag.heading || 'STAY SHARP. STAY HYDRATED.'));
    heading.append(el('p', null, tag.sub || 'Electrolytes and bottles that keep you moving.'));
    wrap.append(heading);

    // Pitch (why-electrolytes-first)
    const pitchText = C.electrolytesPitch ||
      'Sodium is what lets your body hold onto the water you drink. ' +
      'Without it, much of it passes straight through. ' +
      'Replace what you lose first, then top up with water.';
    wrap.append(el('p', { class: 'eh-pitch' }, pitchText));

    // Recommendation card with number badge or "keep handy"
    const recCfg = C.recommendation || {};
    const rec = el('div', { class: 'eh-rec' });
    if (servings > 0) {
      rec.append(el('div', { class: 'eh-num' }, String(servings)));
      const text = el('div', { class: 'eh-rec-text' });
      const headTemplate = servings === 1
        ? (recCfg.servingsSingleHeading || '1 serving recommended today')
        : (recCfg.servingsMultiHeading || '[n] servings recommended today');
      const subTemplate = recCfg.servingsSub || 'Based on your activity, climate and event.';
      // Support both [n] (new, Liquid-safe) and {n} (legacy) placeholders.
      const headFilled = headTemplate
        .replace(/\[n\]/g, String(servings))
        .replace(/\{n\}/g, String(servings));
      text.append(el('strong', null, headFilled));
      text.append(el('span', null, subTemplate));
      rec.append(text);
    } else {
      const ic = el('div', { class: 'eh-num eh-num-light' });
      ic.innerHTML = ICONS.bolt;
      rec.append(ic);
      const text = el('div', { class: 'eh-rec-text' });
      text.append(el('strong', null, recCfg.zeroHeading || 'Worth keeping handy'));
      text.append(el('span', null, recCfg.zeroSub || 'Useful on hot days, after workouts or when you feel run-down.'));
      rec.append(text);
    }
    wrap.append(rec);

    // Product card
    if (prod.url) {
      const a = el('a', { class: 'eh-product', href: prod.url, target: '_blank', rel: 'noopener' });
      if (prod.image) {
        const im = el('div', { class: 'eh-product-img' });
        im.append(el('img', { src: prod.image, alt: prod.name || 'Electrolytes', loading: 'lazy' }));
        a.append(im);
      }
      const body = el('div', { class: 'eh-product-body' });
      body.append(el('div', { class: 'eh-product-name' }, prod.name || 'Electrolytes'));
      if (prod.tagline) body.append(el('div', { class: 'eh-product-tag' }, prod.tagline));
      if (prod.price) body.append(el('div', { class: 'eh-product-price' }, prod.price));
      a.append(body);
      const cta = el('span', { class: 'eh-product-cta' });
      cta.append(document.createTextNode('Shop  '));
      cta.insertAdjacentHTML('beforeend', ICONS.arrow);
      a.append(cta);
      wrap.append(a);
    }

    return wrap;
  }

  function bundleBlock() {
    const b = C.bundle;
    if (!b || !b.url) return null;
    const a = el('a', { class: 'bundle-card', href: b.url, target: '_blank', rel: 'noopener' });
    const im = el('div', { class: 'bundle-img' });
    im.append(el('img', { src: b.image, alt: b.name, loading: 'lazy' }));
    a.append(im);
    const body = el('div', { class: 'bundle-body' });
    body.append(el('div', { class: 'bundle-name' }, b.name));
    body.append(el('div', { class: 'bundle-tag' }, b.tagline));
    a.append(body);
    const cta = el('span', { class: 'bundle-cta' });
    cta.append(document.createTextNode(b.price + '  '));
    cta.insertAdjacentHTML('beforeend', ICONS.arrow);
    a.append(cta);
    return a;
  }

  function sectionDivider(label) {
    const d = el('div', { class: 'res-divider' });
    d.append(el('span', { class: 'res-divider-rule' }));
    d.append(el('span', { class: 'res-divider-label' }, label));
    d.append(el('span', { class: 'res-divider-rule' }));
    return d;
  }

  function results() {
    const r = calculate(state);

    // LEFT: water-balance summary
    const left = el('div', { class: 'result-card' });
    const lh = el('div', { class: 'result-h' });
    lh.append(el('span', { class: 'pip' }), document.createTextNode('Water in your body'));
    left.append(lh);

    const targetSec = el('div', { class: 'result-section' });
    targetSec.append(el('div', { class: 'result-sub' }, 'Your daily hydration target'));
    targetSec.append(rowKV('Total hydration target', fmtMl(r.totalTarget)));
    targetSec.append(rowKV('(−) Estimated water from foods', fmtMl(r.foodWater)));
    if (r.event > 0) targetSec.append(rowKV('(+) Event / exercise bonus', fmtMl(r.event)));
    targetSec.append(rowKV('Hydration target from fluids', fmtMl(r.fluidTarget), { strong: true, kind: 'target' }));

    const intakeSec = el('div', { class: 'result-section' });
    intakeSec.append(el('div', { class: 'result-sub' }, 'How much you currently drink'));
    intakeSec.append(rowKV('Water Intake', fmtMl(r.breakdown.water)));
    intakeSec.append(rowKV('Coffee/Tea/Soft Drinks (−15%)', fmtMl(r.breakdown.coffee_tea_soft)));
    intakeSec.append(rowKV('Alcohol/Wine/Beer (−40%)', fmtMl(r.breakdown.alcohol)));
    intakeSec.append(rowKV('Electrolyte Drink/Milk (+20%)', fmtMl(r.breakdown.electrolyte_milk)));
    intakeSec.append(rowKV('Total daily fluid intake', fmtMl(r.totalIntake), { strong: true }));

    const gapSec = el('div', { class: 'result-section' });
    gapSec.append(el('div', { class: 'result-sub' }, 'Your daily hydration gap'));
    gapSec.append(rowKV('Hydration target from fluids', fmtMl(r.fluidTarget)));
    gapSec.append(rowKV('(−) Total daily fluid intake', fmtMl(r.totalIntake)));
    gapSec.append(rowKV('Total gap', fmtMl(r.gap), { strong: true, kind: 'gap' }));

    const callout = el('div', { class: 'gap-callout' });
    callout.append(
      el('div', { class: 'copy' }, r.gap > 0 ? 'You need this much more fluid today' : 'You\'re hitting your target. Keep it up.'),
      el('div', { class: 'num' }, fmtMl(r.gap))
    );

    left.append(targetSec, intakeSec, gapSec, callout);

    // RIGHT: electrolytes hero + bottles (compact, in same column as summary)
    const right = el('div', { class: 'result-card' });
    right.append(electrolytesHero(state));
    right.append(sectionDivider('Then top up with water'));

    const bottlesHead = el('div', { class: 'bottles-head' });
    bottlesHead.append(el('h4', null, 'Choose your bottle'));
    bottlesHead.append(el('p', null, 'Sized to your daily gap, picked from the Fuel 24 range.'));
    right.append(bottlesHead);
    right.append(bottlesGrid(r));
    right.append(el('a', { class: 'btn btn-primary shop-all', href: C.shopAllUrl, target: '_blank', rel: 'noopener' }, 'Shop all bottles'));

    // Top row (two equal columns)
    const topRow = el('div', { class: 'grid-2 results-top' });
    topRow.append(left, right);

    // Bundle: full-width below for balance
    const bundle = bundleBlock();
    let bundleCard = null;
    if (bundle) {
      bundleCard = el('div', { class: 'result-card results-bundle' });
      const bdh = el('div', { class: 'result-h' });
      bdh.append(el('span', { class: 'pip' }), document.createTextNode('Or grab the lot'));
      bundleCard.append(bdh);
      bundleCard.append(el('p', { class: 'result-p' }, 'Bottle + electrolytes — everything you need to start.'));
      bundleCard.append(bundle);
    }

    const wrap = el('div', { class: 'results-wrap' });
    wrap.append(topRow);
    if (bundleCard) wrap.append(bundleCard);

    const card = el('div', { class: 'calc-card' });
    const header = el('div', { class: 'step-header' });
    header.append(el('h2', null, 'Your results'));
    header.append(unitsToggle());
    card.append(header, wrap, navBar({ nextLabel: 'Start over' }));
    return card;
  }

  // ---------- Units toggle (animated pill) ----------
  function unitsToggle() {
    const t = el('div', { class: 'units-toggle' });
    const m = el('button', { type: 'button', class: 'unit-btn' + (state.units === 'metric' ? ' active' : ''), onclick: () => { state.units = 'metric'; render(); } }, 'Metric');
    const i = el('button', { type: 'button', class: 'unit-btn' + (state.units === 'imperial' ? ' active' : ''), onclick: () => { state.units = 'imperial'; render(); } }, 'Imperial');
    t.append(m, i);
    return t;
  }

  // ---------- Wrap + nav ----------
  function navBar(opts) {
    const bar = el('div', { class: 'nav-bar' });
    bar.append(
      state.step > 1
        ? el('button', { class: 'btn btn-ghost', type: 'button', onclick: () => goTo(state.step - 1) }, 'Previous')
        : el('span')
    );
    const dotsWrap = el('div', { class: 'dots' });
    for (let i = 1; i <= maxStep(); i++) {
      dotsWrap.append(el('span', { class: 'dot' + (i === state.step ? ' active' : i < state.step ? ' done' : '') }));
    }
    bar.append(dotsWrap);
    if (state.step < maxStep()) {
      const nextLabel = state.step === maxStep() - 1 ? 'See results' : 'Next';
      const btn = el('button', { class: 'btn btn-primary', type: 'button', onclick: () => { if (validateStep()) goTo(state.step + 1); } }, nextLabel);
      btn.insertAdjacentHTML('beforeend', ' <span style="display:inline-flex;margin-left:4px;">' + ICONS.arrow + '</span>');
      bar.append(btn);
    } else {
      bar.append(el('button', { class: 'btn btn-ghost', type: 'button', onclick: () => goTo(1) }, opts && opts.nextLabel || 'Start over'));
    }
    return bar;
  }
  function showError(msg) {
    let bar = document.querySelector('.error-bar');
    if (!bar) {
      bar = el('div', { class: 'error-bar' });
      document.querySelector('.calc-card')?.append(bar);
    }
    bar.textContent = msg;
    bar.classList.add('show');
    clearTimeout(showError._t);
    showError._t = setTimeout(() => bar.classList.remove('show'), 3500);
  }
  function validateStep() {
    // Self-heal sensible defaults so Next always works even if a user has done nothing.
    if (state.step === 1) {
      if (!isFinite(state.age)         || state.age < 12         || state.age > 100)        state.age = 25;
      if (!isFinite(state.weightKg)    || state.weightKg < 20    || state.weightKg > 300)   state.weightKg = 80;
      if (!isFinite(state.heightCm)    || state.heightCm < 100   || state.heightCm > 230)   state.heightCm = 170;
      if (state.gender !== 'male' && state.gender !== 'female')                              state.gender = 'male';
    }
    if (state.step === 2) {
      if (!['low','medium','high'].includes(state.activity)) state.activity = 'medium';
      if (!['cold','temperate','hot'].includes(state.climate)) state.climate = 'temperate';
    }
    if (state.step === 3) {
      const ev = state.event;
      if (!ev || typeof ev !== 'object') state.event = { sport: 'none', durationMin: 0, intensity: 'moderate', customMlPerMin: 12 };
      if (!isFinite(ev.durationMin) || ev.durationMin < 0) ev.durationMin = 0;
    }
    return true;
  }
  function wrapStep(title, body) {
    const card = el('div', { class: 'calc-card' });
    const header = el('div', { class: 'step-header' });
    header.append(el('h2', null, title));
    header.append(unitsToggle());
    card.append(header, body, navBar({}));
    return card;
  }

  // ---------- Mount ----------
  function render() {
    const root = document.getElementById('hydration-root');
    if (!root) return;
    root.innerHTML = '';
    let view;
    switch (state.step) {
      case 1: view = step1AboutYou(); break;
      case 2: view = step2Lifestyle(); break;
      case 3: view = step3Event(); break;
      case 4: view = step4Intake(); break;
      case 5: view = results(); break;
      default: view = step1AboutYou();
    }
    root.append(view);
  }

  // ---------- Methodology modal ----------
  function bindModal() {
    const modal = document.getElementById('methodology-modal');
    const opener = document.getElementById('open-methodology');
    if (!modal || !opener) return;
    let lastFocused = null;
    function open() {
      lastFocused = document.activeElement;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeBtn = modal.querySelector('.modal-close');
      closeBtn && closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      lastFocused && lastFocused.focus && lastFocused.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    opener.addEventListener('click', open);
    modal.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', close));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { render(); bindModal(); });
  } else {
    render();
    bindModal();
  }
})();
